import { render, staticRenderFns } from "./TipoOrgaoList.vue?vue&type=template&id=f82205e6"
import script from "./TipoOrgaoList.vue?vue&type=script&lang=js"
export * from "./TipoOrgaoList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports